import { Injectable } from '@angular/core';
import { FascicoloFull } from "../../../common/models/fascicolo/fascicolo-full";
import { RowSezione } from "../../../common/models/fascicolo/row-sezione";
import { VoceSezione } from "../../../common/models/fascicolo/voce-sezione";
import { FormAppelloComponent } from "../form-appello/form-appello.component";
import { FormAppelloViewComponent } from "../form-appello/view/form-appello-view.component";
import { FormCoterziComponent } from "../form-coterzi/form-coterzi.component";
import { FormCoterziViewComponent } from "../form-coterzi/view/form-coterzi-view.component";
import { FormImmobiliareComponent } from "../form-immobiliare/form-immobiliare.component";
import { FormImmobiliareViewComponent } from "../form-immobiliare/view/form-immobiliare-view.component";
import { FormMediazioneComponent } from "../form-mediazione/form-mediazione.component";
import { FormMediazioneViewComponent } from "../form-mediazione/view/form-mediazione-view.component";
import { FormMobiliareComponent } from "../form-mobiliare/form-mobiliare.component";
import { FormMobiliareViewComponent } from "../form-mobiliare/view/form-mobiliare-view.component";
import { FormOrdinarioComponent } from "../form-ordinario/form-ordinario.component";
import { FormOrdinarioViewComponent } from "../form-ordinario/view/form-ordinario-view.component";
import { FormParereComponent } from "../form-parere/form-parere.component";
import { FormParereViewComponent } from "../form-parere/view/form-parere-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import { FormRicorsoCassazioneComponent } from "../form-ricorso-cassazione/form-ricorso-cassazione.component";
import {
  FormRicorsoCassazioneViewComponent
} from "../form-ricorso-cassazione/view/form-ricorso-cassazione-view.component";
import { FascicoloAppello } from "../models/appello/fascicolo-appello";
import { FascicoloCoTerzi } from "../models/coterzi/fascicolo-coterzi";
import { FascicoloImmobiliare } from "../models/immobiliare/fascicolo-immobiliare";
import { FascicoloMediazione } from "../models/mediazione/fascicolo-mediazione";
import { FascicoloMobiliare } from "../models/mobiliare/fascicolo-mobiliare";
import { FascicoloOrdinario } from "../models/ordinario/fascicolo-ordinario";
import { FascicoloParere } from "../models/parere/fascicolo-parere";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";
import { FascicoloRicorsoCassazione } from "../models/ricorso-cassazione/fascicolo-ricorso-cassazione";
import { FascicoloGenerico } from '../models/generico/fascicolo-generico';
import { FormGenericoViewComponent } from '../form-generico/view/form-generico-view.component';
import { FormGenericoComponent } from '../form-generico/form-generico.component';

@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor() { }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'parere': {
        fascicolo = new FascicoloParere();
        break;
      }
      case 'appello': {
        fascicolo = new FascicoloAppello();
        break;
      }
      case 'ordinario': {
        fascicolo = new FascicoloOrdinario();
        break;
      }
      case 'ricorsocassazione': {
        fascicolo = new FascicoloRicorsoCassazione();
        break;
      }
      case 'esecuzionepressoterzi': {
        fascicolo = new FascicoloCoTerzi();
        break;
      }
      case 'esecuzioneimmobiliare': {
        fascicolo = new FascicoloImmobiliare();
        break;
      }
      case 'esecuzionemobiliare': {
        fascicolo = new FascicoloMobiliare();
        break;
      }
      case 'mediazione': {
        fascicolo = new FascicoloMediazione();
        break;
      }
      case 'recuperocreditistragiudiziale': {
        fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
        break;
      }
      case 'genericogiudiziale': {
        fascicolo = new FascicoloGenerico();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;

    switch (idFormTenant) {
      case 'TriPar_PRD': {
        component = view ? FormParereViewComponent : FormParereComponent; // "PARERE",
        break;
      }
      case 'TriApp_PRD': {
        component = view ? FormAppelloViewComponent : FormAppelloComponent; // "APPELLO",
        break;
      }
      case 'TriOrd_PRD': {
        component = view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO",
        break;
      }
      case 'TriRca_PRD': {
        component = view ? FormRicorsoCassazioneViewComponent : FormRicorsoCassazioneComponent; // "RICORSO IN CASSAZIONE",
        break;
      }
      case 'TriEpt_PRD': {
        component = view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI",
        break;
      }
      case 'TriEim_PRD': {
        component = view ? FormImmobiliareViewComponent : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE",
        break;
      }
      case 'TriEmo_PRD': {
        component = view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE",
        break;
      }
      case 'TriMed_PRD': {
        component = view ? FormMediazioneViewComponent : FormMediazioneComponent; // "MEDIAZIONE",
        break;
      }
      case 'TriRec_PRD': {
        component = view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE"
        break;
      }
      case 'TriGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic: string, assegnatario?:string): RowSezione[] {
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    let esiti = this.getEsitiFromCopertina(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    switch (genericFascicolo) {
      case 'parere': {
        return [new RowSezione(null, [
          new VoceSezione(4, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(4, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(4, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          // new VoceSezione(4, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato),
            new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione('Richiesta parere', [
            new VoceSezione(4, 'date', 'Data richiesta', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'text', 'Tipo richiedente', fascicolo.copertina.campi.tipoRichiedente),
            new VoceSezione(4, 'text', 'Richiedente', fascicolo.copertina.campi.richiedente)
          ]),
          new RowSezione('Parere', [
            new VoceSezione(12, 'text', 'Sintesi parere', fascicolo.copertina.campi.sintesiParere)
          ]),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'appello': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),          
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ordinario':
      case 'genericogiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),          
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsocassazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
        new RowSezione(null, [
          new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
        ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.praticaBase.intestazione.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzionepressoterzi': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          new RowSezione('Terzi pignorati', [
            new VoceSezione(12, 'text', 'Soggetti terzi pignorati', fascicolo.copertina.campi.listaTerziPignorati)
          ]),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzioneimmobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzionemobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'mediazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'text', 'Organismo di mediazione', fascicolo.copertina.campi.organismoMediazione),
            new VoceSezione(6, 'text', 'Sede mediazione', fascicolo.copertina.campi.sedeIncontro),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'recuperocreditistragiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)',
              (fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? (fascicolo.copertina.campi.tipoUltimaLetteraDiffida +
                ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')') : '')),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }

  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
